/* script */
//
//
//
//
//
//
//
//
//
//


import UploadButton from './UploadButton.vue';
import { v4 as uuid } from 'uuid';

const __vue_script__ = {
    name: 'GenericFpTypeUploadButton',

    components: { UploadButton },

    props: {
        eid: {
            type: String,
            required: true
        },

        fpType: {
            type: String,
            required: true
        },

        metadataForType: {
            type: Object,
            default: () => null
        },
    },

    data() {
        return {
            uploaderScope: uuid()
        };
    },

    computed:{
        canUseVueUploader() {
            // We cannot check this._attachment_specs here because of the default backward compatibility it contains
            return this.hasAssetFpType && !!this.metadataForType?._attachment_specs;
        },

        hasAssetFpType() {
            return this.$services.metadata.isAssetFpType(this.metadataForType);
        },

        attachmentSpecs(){
            return this.$utils.metadata.getAttachmentSpecs(this.metadataForType);
        }
    },

    async created() {
        this.metadataForType = this.metadataForType || await this.$services.metadata.getMetadataForType(this.eid, this.fpType);
    },

    methods: {
        uploaded(data) {
            if (data?.scope !== this.uploaderScope) {
                return;
            }

            this.$emit('uploaded', data);
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.attachmentSpecs && _vm.canUseVueUploader
    ? _c("upload-button", {
        staticClass: "btn",
        attrs: {
          scope: _vm.uploaderScope,
          label: _vm.$t("general.upload"),
          "fp-type": _vm.fpType,
          "attachment-specs": _vm.attachmentSpecs,
        },
        on: { uploaded: _vm.uploaded },
      })
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/uploader/GenericFpTypeUploadButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__